import Colors from "../../styles/colors";

const baseButton = {
  border: "none",
  padding: "12px 18px",
  borderRadius: 12,
  fontSize: 14,
  fontWeight: 700,
  letterSpacing: "0.02em",
  cursor: "pointer",
  transition: "all 0.25s ease",
  boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
};

/* ===============================
   DESKTOP STYLES (DEFAULT)
=============================== */
const styles = {
  card: {
    background: "linear-gradient(135deg, #ffffff, #e1edf8)",
    borderRadius: 18,
    padding: "24px 24px 22px",
    marginBottom: 26,
    boxShadow: "0 10px 28px rgba(0,0,0,0.12)",
    transition: "all 0.3s ease",
    cursor: "pointer",
    border: "1px solid #e2e8f0",
    color: "#0f172a",
    lineHeight: 1.55,
  },

  cardHover: {
    background: "linear-gradient(135deg, #f8fafc, #dbeafe)",
  },

  cancelledBadge: {
    marginTop: 8,
    display: "inline-block",
    background: "#fee2e2",
    color: "#b91c1c",
    padding: "5px 12px",
    borderRadius: 999,
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: "0.03em",
  },

  /* ===== Buttons ===== */
  bookBtn: {
    ...baseButton,
    background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
    color: "#ffffff",
  },

  joinBtn: {
    ...baseButton,
    background: "linear-gradient(135deg, #16a34a, #15803d)",
    color: "#ffffff",
  },

  cancelBtn: {
    ...baseButton,
    background: "#ffffff",
    color: "#dc2626",
    border: "1px solid #fecaca",
    boxShadow: "none",
  },

  upgradeBtn: {
    ...baseButton,
    background: "linear-gradient(135deg, #f59e0b, #d97706)",
    color: "#ffffff",
  },

  expiredBtn: {
    ...baseButton,
    background: "#f1f5f9",
    color: "#64748b",
    cursor: "not-allowed",
    boxShadow: "none",
  },

  bookingClosedBtn: {
    ...baseButton,
    background: "#e2e8f0",
    color: "#475569",
    cursor: "not-allowed",
    boxShadow: "none",
  },

  preparingBtn: {
    ...baseButton,
    background: "linear-gradient(135deg, #fb923c, #f97316)",
    color: "#ffffff",
    cursor: "not-allowed",
  },

  preparingText: {
    color: "#ffffff",
    fontWeight: 700,
  },

  dropdownToggle: {
    marginTop: 16,
    padding: "4px 0",
    border: "none",
    background: "transparent",
    color: "#2563eb",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 14,
  },

  /* ===== Agenda ===== */
  agendaGrid: {
    marginTop: 18,
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: 16,
  },

  agendaCard: {
    background: "#ffffff",
    padding: "16px",
    borderRadius: 14,
    border: "1px solid #e2e8f0",
  },

  agendaTitle: {
    fontWeight: 700,
    fontSize: 14,
    marginBottom: 10,
    color: "#1d4ed8",
  },

  sectionTitle: {
    fontWeight: 600,
    fontSize: 13,
    marginBottom: 6,
    marginTop: 8,
    color: "#334155",
  },

  question: {
    fontSize: 13,
    color: "#475569",
    paddingLeft: 8,
    marginBottom: 4,
  },

  bookedBadge: {
    marginTop: 6,
    padding: "4px 10px",
    backgroundColor: "#E6F9F0",
    color: "#047857",
    fontSize: 16,
    fontWeight: 600,
    borderRadius: 12,
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
  },

  /* ===============================
     MOBILE OVERRIDES
  =============================== */
  mobile: {
    card: {
      padding: "18px",
      borderRadius: 14,
    },

    title: {
      fontSize: 18,
    },

    subtitle: {
      fontSize: 12,
    },

    timeText: {
      fontSize: 22,
    },

    badge: {
      fontSize: 14,
      padding: "4px 10px",
    },

    button: {
      fontSize: 13,
      padding: "10px 14px",
      borderRadius: 10,
    },

    agendaGrid: {
      gridTemplateColumns: "1fr",
      gap: 12,
    },

    agendaTitle: {
      fontSize: 13,
    },

    question: {
      fontSize: 12,
    },
  },
};

export default styles;
